// src/Auth/authservice.js
import {auth, db} from '../config/firebase';
import {createUserWithEmailAndPassword, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup} from "firebase/auth";
import {doc, setDoc, getDoc} from "firebase/firestore"; // Importa funciones para Firestore
import {signOut} from "firebase/auth";

export const cleanEmail = (email) => {
    return email.replace('.', ','); // Reemplazar '.' con ',' para que sea un ID válido
};

// Función para registrar un usuario
export const registerUser = async (email, password, userName) => {
    try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;

        // Asegurarse de que todos los campos tengan valores válidos
        const userData = {
            email: email,
            name: userName || '',
            nameLowerCase: (userName || '').toLowerCase(), // Guardar el nombre en minúsculas
            followers: [],
            following: [],
            registrationDate: new Date().toISOString()
       };

        // Guardar usuario en Firestore usando el UID del usuario
        await setDoc(doc(db, "users", user.uid), userData);

        return user;
   } catch (error) {
        console.error("Error al registrar usuario:", error.message);
        throw error;
   }
};

// Función para verificar si el usuario existe en la base de datos
export const checkUserExists = async (uid) => {
    const userDocRef = doc(db, "users", uid);
    const userDoc = await getDoc(userDocRef);
    return userDoc.exists();
};

// Función para iniciar sesión
export const loginUser = async (email, password) => {
    try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        return user;
   } catch (error) {
        console.error("Error al iniciar sesión:", error.message);
        throw error;
   }
};

// Función para iniciar sesión con Google
export const loginWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
        const result = await signInWithPopup(auth, provider);
        const user = result.user;
        const userName = user.displayName;

        // Leer el documento actual del usuario
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);

        // Si no existe, crear con todos los campos necesarios
        if (!userDoc.exists()) {
            const userData = {
                email: user.email,
                name: userName || '',
                nameLowerCase: (userName || '').toLowerCase(),
                followers: [],
                following: [],
                recetasCompartidas: [],
                recetasFavoritas: [],
                registrationDate: new Date().toISOString()
           };
            await setDoc(userDocRef, userData);
       } else {
            // Si existe, asegúrate de que los arrays existen (merge)
            const data = userDoc.data();
            await setDoc(userDocRef, {
                followers: data.followers || [],
                following: data.following || [],
                recetasCompartidas: data.recetasCompartidas || [],
                recetasFavoritas: data.recetasFavoritas || []
           }, {merge: true});
       }

        return user;
   } catch (error) {
        console.error("Error al iniciar sesión con Google:", error.message);
        throw error;
   }
};

// Función para cerrar sesión
export const logoutUser = async () => {
    try {
        await signOut(auth);
   } catch (error) {
        console.error("Error al cerrar sesión:", error.message);
        throw error;
   }
};